import React from "react";
import Modal from "react-modal";
import toast from "react-hot-toast";

import { useAppSelector, useAppDispatch } from "../../../../../../app/hooks";
import { closeRevealModal } from "../../../../apiKeysSlice";

import "./RevealApiKeyModal.scss";

const modalStyles = {
  content: {
    top: "50%", left: "50%", right: "auto", bottom: "auto",
    marginRight: "-50%", transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF", maxWidth: "480px",
  },
};

export function RevealApiKeyModal() {
  const dispatch = useAppDispatch();
  const createdKey = useAppSelector((state) => state.apiKeys.createdKey);

  const onCopy = async () => {
    if (!createdKey) return;
    try {
      await navigator.clipboard.writeText(createdKey.key);
      toast.success("Copied to clipboard.");
    } catch {
      toast.error("Couldn't copy. Select the key and copy it manually.");
    }
  };

  const onDone = () => dispatch(closeRevealModal());

  return (
    <Modal isOpen={!!createdKey} onRequestClose={onDone} style={modalStyles}>
      <div className="reveal-api-key-modal-component">
        <div className="title">API key created</div>
        <div className="warning">
          Copy this key now. For security, you won't be able to see it again.
        </div>
        {createdKey && (
          <div className="key-row">
            <code className="key-value">{createdKey.key}</code>
            <button type="button" className="copy-button" onClick={onCopy}>
              Copy
            </button>
          </div>
        )}
        <button type="button" className="done-button" onClick={onDone}>
          I've copied it
        </button>
      </div>
    </Modal>
  );
}
